(function () {
  var loaded = false;

  function run(fn) {
    try { fn(); } catch (e) {}
  }

  function loadScript(src) {
    return new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = resolve;
      document.head.appendChild(s);
    });
  }

  async function start() {
    if (loaded) return;
    loaded = true;

    // Load during idle time (best for TBT)
    var go = async function () {
      var queue = window.__DELAY_JS_QUEUE__ || [];
      for (var i = 0; i < queue.length; i++) {
        await loadScript(queue[i]);
      }
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(function(){ run(go); }, { timeout: 2000 });
    } else {
      setTimeout(function(){ run(go); }, 1200);
    }
  }

  // Trigger on first user interaction
  ['pointerdown','touchstart','scroll','keydown','mousemove'].forEach(function (ev) {
    window.addEventListener(ev, start, { passive: true, once: true });
  });

  // Fallback: load after window load
  window.addEventListener('load', function () {
    setTimeout(start, 2500);
  });
})();
